import { Component, OnInit, ViewChild } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { Router } from '@angular/router';
import { LoadDataService } from '../../services/load-data.service';

import SwiperCore, {
  Pagination
} from 'swiper';
import { ProfileService } from 'src/app/services/profile.service';
SwiperCore.use([Pagination]);
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

@Component({
  selector: 'app-onboard',
  templateUrl: './onboard.page.html',
  styleUrls: ['./onboard.page.scss'],
})
export class OnboardPage implements OnInit {
  
  @ViewChild('swiper') swiper: SwiperComponent;
  config: SwiperOptions = {
    // pagination: true
    // breakpoints: {
    //   1100: {
    //     width: 580,
    //     slidesPerView: 1,
    //     spaceBetween: 600
    //   }
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      // renderBullet: function (index, className) {
      //   return '<span class="' + className + '">' + (index + 1) + '</span>';
      // },
    }
  };

  touchAllowed = false;

  constructor(
    private router: Router,
    private loadData: LoadDataService,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    SecureStoragePlugin.clear()
      .then(x => console.log('secure-storage cleared'));
  }

  swiperSlideChanged(e){
  }

  next() {
    this.swiper.swiperRef.slideNext(500);
  }

  prev() {
    this.swiper.swiperRef.slidePrev(500);
  }

  last() {
    this.swiper.swiperRef.slideTo(2,500);
  }

  toggleTouch(){
    this.touchAllowed = !this.touchAllowed;
    this.swiper.swiperRef.allowTouchMove = this.touchAllowed;
  }

  endOb( signIn: boolean = false ){
    this.loadData.setOB();
    signIn ? this.noSignIn() : this.signIn();
  }

  signIn(){
    this.profileService.signIn();
  }

  noSignIn(){
    this.profileService.anonymousSignIn();
    this.router.navigate(['navigator/home']);
  }

}
